import { Typography } from "@mui/material"
import { describeTradeWithoutSkills } from "./describe-trade-without-skills"

/**
 * What a trade row shows when the trade has no skills of its own. A trade that conditional
 * rules send work to is not idle, so it says so rather than a bare "No skills".
 */
export function TradeNoSkillsLabel({ conditionalRuleCount }) {
    return (
        <Typography variant="body2" color="text.secondary" data-cy="trade-no-skills">
            {describeTradeWithoutSkills(conditionalRuleCount)}
        </Typography>
    )
}
